import { ConnectComponent } from "./connect/connect.component";
import { ChannelComponent } from "./channel/channel.component";
import { PostListItemComponent } from "./post-list-item/post-list-item.component";
import { FeaturedRailComponent } from "./featured-rail/featured-rail.component";
import { MemberResultsOverlayComponent } from "./member-results-overlay/member-results-overlay.component";

import { CreatePostInputComponent } from "./create-post-input/create-post-input.component";

import { MessagesComponent } from "./messages/messages.component";

import { MessagesDetailComponent } from "./messages-detail/messages-detail.component";
import { BetaDetailsComponent } from "./beta-details/beta-details.component";
import { CommunityOnboardingWizardComponent } from "./onboarding-wizard/community-onboarding-wizard.component";

export const COMMUNITY_COMPONENTS = [
  ConnectComponent,
  ChannelComponent,
  PostListItemComponent,
  FeaturedRailComponent,
  MemberResultsOverlayComponent,
  CreatePostInputComponent,
  MessagesComponent,
  MessagesDetailComponent,
  BetaDetailsComponent,
  CommunityOnboardingWizardComponent,
];

export * from "./connect/connect.component";
export * from "./channel/channel.component";
export * from "./post-list-item/post-list-item.component";
export * from "./post-list-item/post-list-item.component";
export * from "./featured-rail/featured-rail.component";
export * from "./member-results-overlay/member-results-overlay.component";
export * from "./create-post-input/create-post-input.component";
export * from "./messages/messages.component";
export * from "./messages-detail/messages-detail.component";
export * from "./beta-details/beta-details.component";
export * from "./onboarding-wizard/community-onboarding-wizard.component";
